import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabaseClient } from '../utils/supabaseClient';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [authState, setAuthState] = useState({ checked: false, user: null });

  useEffect(() => {
    const check = async () => {
      const { data: { user } } = await supabaseClient.auth.getUser();
      setAuthState({ checked: true, user });
    };
    check();
  }, []);

  if (!authState.checked) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!authState.user) {
    return <Navigate to="/" replace />;
  }

  const storedRole = localStorage.getItem('userRole') || 'member';

  if (requiredRole === 'admin' && storedRole !== 'admin') {
    return <Navigate to="/member/dashboard" replace />;
  }

  if (requiredRole === 'member' && storedRole === 'admin') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
